import { NgModule } from '@angular/core';
import { PageModule } from '@layouts/page/page.module';
import { LayoutModule as LibraryLayoutModule } from '@library/ui/layout/layout.module';
import { CardModule } from './card/card.module';
import { GrowContainerModule } from '@layouts/grow-container/grow-container.module';

const Modules = [
  CardModule,
  LibraryLayoutModule,
  PageModule,
  GrowContainerModule,
];

@NgModule({
  imports: Modules,
  exports: Modules,
})
export class LayoutsModule { }
